<template>
  <div class="page">
    <h2>Resources &amp; Solutions</h2>

    <div class="hero">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <h3 class="text">Buyer Program</h3>
        <p>
          A passive no-cost program designed to help you acquire financial service practices and stay informed of opportunities in your selected areas.
        </p>

        <a
          href="http://www.successionresource.com/wp-content/uploads/2017/03/SRG-Buyer-Program.pdf"
          class="btn btn-green hero_btn_width">
          Download Info Sheet
        </a>

        <a
          :href="`${myCompassUrl}/module_questionnaire/buyer`"
          class="btn btn-green hero_btn_width">
          Submit Buyer Profile
        </a>
      </div>
    </div>

    <div class="page-container">
      <div class="page-col services_col">
        <img class="page-img-logo" src="../../assets/logo/loginlogo.png" />
        <!-- <v-img :src="logo_img" class="page-img-logo" atl="Succession Resource Group"></v-img> -->

        <div class="d-flex justify-space-between mb-2">
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[0].url" target="_blank" class="service_link">
              <customIcon
                :name="services[0].icon"
                :class="`${services[0].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[0].name }}</div>
            </a>
          </div>
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[1].url" target="_blank" class="service_link">
              <customIcon
                :name="services[1].icon"
                :class="`${services[1].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[1].name }}</div>
            </a>
          </div>
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[2].url" target="_blank" class="service_link">
              <customIcon
                :name="services[2].icon"
                :class="`${services[2].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[2].name }}</div>
            </a>
          </div>
        </div>

        <div class="d-flex justify-space-between mb-2">
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[3].url" target="_blank" class="service_link">
              <customIcon
                :name="services[3].icon"
                :class="`${services[3].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[3].name }}</div>
            </a>
          </div>
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[4].url" target="_blank" class="service_link">
              <customIcon
                :name="services[4].icon"
                :class="`${services[4].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[4].name }}</div>
            </a>
          </div>
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[5].url" target="_blank" class="service_link">
              <customIcon
                :name="services[5].icon"
                :class="`${services[5].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[5].name }}</div>
            </a>
          </div>
        </div>

        <div class="d-flex justify-space-between mb-2">
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[6].url" target="_blank" class="service_link">
              <customIcon
                :name="services[6].icon"
                :class="`${services[6].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[6].name }}</div>
            </a>
          </div>
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[7].url" target="_blank" class="service_link">
              <customIcon
                :name="services[7].icon"
                :class="`${services[7].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[7].name }}</div>
            </a>
          </div>
          <div class="d-inline align-center px-3" style="width: 33%">
            <a :href="services[8].url" target="_blank" class="service_link">
              <customIcon
                :name="services[8].icon"
                :class="`${services[8].color}--text`"
                class="ma-0 pa-0 icon-size" />
              <div class="d-block mt-n4">{{ services[8].name }}</div>
            </a>
          </div>
        </div>

        <div class="services_btn">
          <a
            href="https://www.successionresource.com/" target="_blank"
            class="btn btn-green">
            Learn More About SRG
          </a>
        </div>
      </div>

      <div class="page-col lw_col">
        <img class="lw_logo" src="./assets/LW_SRG_Blacklogo_powered@2x.png" />
        <p>
          LendingWell is an online lender/financing matching tool developed by Succession Resource Group.
        </p>
        <p>
          LendingWell was designed specifically for advisors to assist with finding the optimal lender(s) for your financing needs. Each lender has unique requirements, loan terms, and “credit box.” Answer a few simple questions to evaluate your eligibility and find lenders who ideally matched for your type of financing needs. Once matched, you can connect with lenders.
        </p>
        <div class="lw_btn">
          <a
            href="https://www.lending-well.com/" target="_blank"
            class="btn btn-green">
            Learn More About LendingWell
          </a>
        </div>
      </div>
    </div>

    <BottomColorBar />
  </div>
</template>

<script>
  import appUrls from '../../helpers/environment';
  import BottomColorBar from './partials/BottomColorBar'
  import logo_img from '../../assets/SRGLogo_full_color_2022.svg';

  export default {
    name: 'PdfPage8',
    components: {
      BottomColorBar,
    },

    data () {
      return {
        myCompassUrl: appUrls.mycompass,
        logo_img: logo_img,
        services: [
          {   
            name: 'FA CMA Valuation', 
            icon: 'valuation', 
            color: 'value', 
            url: 'https://www.successionresource.com/facmavaluation/'
          },
          { 
            name: 'Entity Support', 
            icon: 'entity-support', 
            color: 'improve', 
            url: 'https://www.successionresource.com/entity-formation/'
          },
          { 
            name: 'Employee Resource', 
            icon: 'employment-resources', 
            color: 'improve',
            url: 'https://www.successionresource.com/talent-development/'
          },
          {   
            name: 'Contingency Planning', 
            icon: 'contingency', 
            color: 'protect', 
            url: 'https://www.successionresource.com/contingency-planning/'
          },
          { 
            name: 'Deal Support', 
            icon: 'deal-support', 
            color: 'grow', 
            url: 'https://www.successionresource.com/deal-support/'
          },{ 
            name: 'Merger', 
            icon: 'merger', 
            color: 'grow', 
            url: 'https://www.successionresource.com/advisor-merger-support/'
          },
          { 
            name: 'Seller Advocacy', 
            icon: 'seller-advocacy', 
            color: 'exit', 
            url: 'https://www.successionresource.com/seller-advocacy/'
          },{ 
            name: 'Succession Blueprint', 
            icon: 'succession', 
            color: 'exit', 
            url: 'https://www.successionresource.com/succession-planning/'
          },{ 
            name: 'Second Look', 
            icon: 'second-look', 
            color: 'exit', 
            url: 'https://successionresource-6155808.hs-sites.com/secondlook'
          }
        ]
      }
    },
  }
</script>

<style scoped>
  h2 {
    text-align: center;
    margin: 0;
    padding: 30px 0;
  }

  .hero {
    position: relative;
    height: 345px;
    width: 100%;

    background-image: url('./assets/buyer-program-hero.jpg');
    background-size: cover;
  }

  .hero-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background-color: rgba(0, 0, 0, 0.2);
    z-index: 2;
  }

  .hero-content {
    height: 100%;
    width: 350px;
    padding: 30px 0 0 50px;

    position: relative;
    z-index: 3;
  }

  .hero-content h3,
  .hero-content p {
    color: white;
  }

  .hero-content h3 {
    margin-bottom: 10px;
  }

  .hero-content .btn {
    margin: 20px 0 0;
    width: 260px;
  }

  .icon-size {
    width: 80px;
  }

  .page-container {
    display: flex;
  }

  .page-col {
    padding: 40px 30px 54px 30px;
    width: 50%;
  }

  .page-img-wheel {
    height: 350px;
    width: 350px;
  }

  .page-img-logo {
    width: 190px;
    margin: 0 auto;
  }
  .service_link {
    text-decoration: none;
    color: inherit;
  }

  .services_col {
    display: inline;
    height: 100%;
    text-align: center;
  }
  .services_btn {
    width: 100%;
    margin-top: 50px;
  }

  .lw_col {
    display: inline;
    height: 100%;
    background-color: #DEF1F4;
  }
  .lw_col p {
    margin: 20px auto;
    text-align: justify;
  }
  .lw_logo {
    width: 100%;
    margin: 10px auto 20px;
  }
  .lw_btn {
    width: 100%;
    margin-top: 140px;
  }

  .btn {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/PdfPage8.vue